import * as R from 'ramda'

import InvoiceType, { InvoiceTypeDisplayName } from '~/constants/InvoiceType'
import type { InvoiceOrEstimate } from '~/types'

/**
 * Mirrors InvoiceDialog / InvoiceBody logic for whether loaded invoice data is an estimate.
 * TODO: simplify once graphQL invoice model maps to portal `type === InvoiceType.ESTIMATE`.
 */
export function invoiceFromStateIndicatesEstimate(
  invoiceFromState: InvoiceOrEstimate | null | undefined,
): boolean {
  if (!invoiceFromState) {
    return false
  }
  return (
    invoiceFromState.type === InvoiceType.ESTIMATE ||
    R.prop('invoiceType', invoiceFromState) ===
      InvoiceType.ESTIMATE.toUpperCase()
  )
}

export function getInvoiceTypeDisplayLabel(
  isEstimate: boolean,
  invoice: InvoiceOrEstimate,
): string {
  if (isEstimate) {
    return InvoiceTypeDisplayName[InvoiceType.ESTIMATE]
  }
  if (invoice.type) {
    return InvoiceTypeDisplayName[invoice.type as InvoiceType] || invoice.type
  }
  return InvoiceTypeDisplayName[InvoiceType.INVOICE]
}

export function getInvoiceNumberSuffix(invoice: InvoiceOrEstimate): string {
  return invoice.invoiceNo ? ` ${invoice.invoiceNo}` : ''
}

export function formatInvoiceHeaderSubtitle(
  invoiceTypeLabel: string,
  invoiceNoSuffix: string,
  clientName: string,
  patientName: string | undefined,
): string {
  return `${invoiceTypeLabel}${invoiceNoSuffix}: ${[
    clientName,
    patientName,
  ].join(' | ')}`
}
